module.exports = __webpack_public_path__ + "img/defence-24-com.ba30348c.svg";